module.exports = __webpack_public_path__ + "static/media/five.da9c8bcc.svg";